import React, { Component } from "react";
import { reduxForm, FieldArray, arrayPush } from "redux-form";
import { Form, FormGroup, Modal } from "react-bootstrap";
import _ from "lodash";

import Steps from "../../../../components/common/steps/Steps";
import Button from "../../../../components/common/button/Button";
import Error from "../../../../components/common/error/Error";
import ReferenceForm from "./ReferenceForm";
import styles from "./References.scss";

import example from "../../../../assets/images/screenshots/user-references-example.png";

const steps = [
  {
    caption: "Your Profile",
    url: "complete-profile"
  },
  {
    caption: "Professional Skills",
    url: "skills"
  },
  {
    caption: "Endorsements",
    url: "endorsement"
  }
];

class References extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      showStep: 2
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  componentDidMount() {
    this.props.dispatch(arrayPush("references", "work_references", {}));
    this.props.dispatch(arrayPush("references", "work_references", {}));
    this.props.dispatch(arrayPush("references", "work_references", {}));
  }

  renderModal() {
    return (
      <Modal
        show={this.state.showModal}
        onHide={this.handleClose}
        dialogClassName={styles.modalContainer}
      >
        <Modal.Body className={styles.modalBody}>
          <img src={example} className={styles.image} />

          <div className={styles.CTAContainer}>
            <Button isSmall label="Close" onClick={this.handleClose} />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    const { handleSubmit, submitting, valid } = this.props;

    return (
      <section className={styles.references}>
        <div className={styles.header}>
          <Steps steps={steps} activeStep={this.state.showStep} />
        </div>
        <div className={styles.content}>
          <h2 className={styles.title}>Endorsements</h2>

          <Form onSubmit={handleSubmit}>
            <div className={styles.form}>
              <FormGroup>
                <div className={styles.sectionDescription}>
                  We collect endorsements from your work colleagues to verify
                  your work history and experience. You need endorsements from
                  at least two people for your application to be approved.
                </div>
                <div className={styles.sectionDescription}>
                  The endorsement form is quick and easy to complete.{" "}
                  <strong>It should take less than 5 minutes.</strong>
                  <a
                    className={styles.linkModal}
                    onClick={e => this.handleOpen(e)}
                  >
                    {" "}
                    Click here{" "}
                  </a>
                  to see the endorsement form.
                </div>
              </FormGroup>
              <FormGroup>
                <div className={styles.dividerDouble} />

                <FormGroup>
                  <FieldArray
                    name="work_references"
                    component={ReferenceForm}
                    workRelations={this.props.workRelations}
                  />
                </FormGroup>

                <div md={12} style={{ textAlign: "center" }}>
                  <Button
                    isPrimary
                    type="submit"
                    size={"large"}
                    label="SAVE + CONTINUE >"
                    isDisabled={!valid || submitting}
                  />
                  <Error />
                </div>
              </FormGroup>
            </div>
          </Form>
        </div>

        {this.renderModal()}
      </section>
    );
  }
}

const validate = values => {
  const EMAIL_ERROR =
    "Please enter unique email addresses for each of your references.";

  const errors = {};
  const firstEmail = _.get(values, "work_references.[0].email");
  const secondEmail = _.get(values, "work_references.[1].email");
  const thirdEmail = _.get(values, "work_references.[2].email");

  errors.work_references = [];

  if (firstEmail && (firstEmail === secondEmail || firstEmail === thirdEmail)) {
    errors.work_references[0] = {
      email: EMAIL_ERROR
    };
  }

  if (
    secondEmail &&
    (secondEmail === firstEmail || secondEmail === thirdEmail)
  ) {
    errors.work_references[1] = {
      email: EMAIL_ERROR
    };
  }

  if (thirdEmail && (thirdEmail === firstEmail || thirdEmail === secondEmail)) {
    errors.work_references[2] = {
      email: EMAIL_ERROR
    };
  }

  return errors;
};

References = reduxForm({
  form: "references",
  validate
})(References);

export default References;



// WEBPACK FOOTER //
// ./src/routes/candidate/references/components/References.js